import React, { useState, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { Button } from "reactstrap";
import swal from 'sweetalert';
import PlanHeader from './PlanHeader';
import Feature from './Feature';
import { AppContext } from '../../../context/app-context';
import FAQ from './FAQ';
import Testimonial from './Testimonial';

import weightLossHImg from '../../../assets/images/DietPlans/category/header-weight-loss.jpg';
import weightLossBImg from '../../../assets/images/DietPlans/diet-plan-benefit/weight-loss.svg';

import prediabetesHImg from '../../../assets/images/DietPlans/category/header-prediabetes.jpg';
import prediabetesBImg from '../../../assets/images/DietPlans/diet-plan-benefit/prediabetes.svg';

import muscleGainHImg from '../../../assets/images/DietPlans/category/header-muscle-gain.jpg';
import muscleGainBImg from '../../../assets/images/DietPlans/diet-plan-benefit/muscle-gain.svg';

import diabetesHImg from '../../../assets/images/DietPlans/category/header-diabetes.jpg';
import diabetesBImg from '../../../assets/images/DietPlans/diet-plan-benefit/diabetes.svg';

import hypertensionHImg from '../../../assets/images/DietPlans/category/header-hypertension.jpg';
import hypertensionBImg from '../../../assets/images/DietPlans/diet-plan-benefit/hypertension.svg';

import pcodHImg from '../../../assets/images/DietPlans/category/header-pcod.jpg';
import pcodBImg from '../../../assets/images/DietPlans/diet-plan-benefit/pcod.svg';

import thyroidHImg from '../../../assets/images/DietPlans/category/header-thyroid.jpg';
import thyroidBImg from '../../../assets/images/DietPlans/diet-plan-benefit/thyroid.svg';

import personalisedImg from '../../../assets/images/DietPlans/diet-plan-feature/personalised.svg';

import { useDiet } from '../../../hooks/useDiet';

import ajaySajwan from '../../../assets/images/DietPlans/user/ajay-sajwan.png';
import sheetal from '../../../assets/images/DietPlans/user/sheetal.png';
import DietPlanTimer from './DietPlanTimer';
import RadioButton from './RadioButton';

const category = {
    "weight_loss" : {
        title: "Weight loss",
        subtitle: "Something for everyone, we've got you covered 360 degrees!",
        benefit: weightLossBImg,
        header: weightLossHImg,
        userTestimonial: {
            name: 'Ajay sajwan',
            image: ajaySajwan,
            description: "While working on my diet, i’ve seen changes in my cholestrol level. It has reduced from 249mg/dL to 114mg/dL. The plan worked perfectly! Thanks again!"
        }
    }, 
    "pre_diabetes" : {
        title: "Pre diabetes",
        subtitle: "Customised, guilt free health plan to keep your sugar on the track.",
        benefit: prediabetesBImg,
        header: prediabetesHImg
    },
    "diabetes" : {
        title: "Diabetes",
        subtitle: "Don't let your guilt play with your sugar levels, play safe with our diet plans.",
        benefit: diabetesBImg,
        header: diabetesHImg
    },
    "muscle_gain" : {
        title: "Muscle gain",
        subtitle: "Bulk-up with our high protein meal plans.",
        benefit: muscleGainBImg,
        header: muscleGainHImg
    },
    "hypertension" : {
        title: "Hypertension",
        subtitle: "Approach us to reduce your tension",
        benefit: hypertensionBImg,
        header: hypertensionHImg
    },
    "pcod" : {
        title: "PCOD",
        subtitle: "Team up with our nutritionist to alleviate your symptoms.",
        benefit: pcodBImg,
        header: pcodHImg,
        userTestimonial: {
            name: 'Sheetal',
            image: sheetal,
            description: "PCOD diet has allowed me to take charge of my health in a holistic manner, and make the necessary lifestyle changes to keep my symptoms in check. I'm truly grateful."
        }
    },
    "thyroid" : {
        title: "Thyroid",
        subtitle: "A sustainable & personalised diet plan to help you treat your thyroid",
        benefit: thyroidBImg,
        header: thyroidHImg
    }
}
const PlanDetail = () => {

    const { categoryId, dietPlanId } = useParams();
    const [state, dispatch] = useContext(AppContext);
    const { makeDietPayment } = useDiet();
    const categoryTemp = category[categoryId];
    const [open, setOpen] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const osType = state?.user?.osType;
    const user = state?.user;

    const [selectedPlanType, setselectedPlanType] = useState('');
    
    localStorage.setItem('planType', categoryId);

    const onClickMakePayment = (paymentType) => {

        if(dietPlanId){
            setOpen(false);
            swal({
                className: "swal-height-width-change",
                title: "Diet plan exists",
                text: "You can only be on one diet plan at a time. You can buy a new diet plan post expiry of existing plan.",
                buttons: "Okay"
            })
        }else {
            
            if(osType){
                setIsDisabled(true);
                if(paymentType === 'upi')
                    setOpen(false);
                makeDietPayment(selectedPlanType, categoryId, paymentType);
            }else {
                setOpen(false);
                swal({
                    className: "swal-height-width-change",
                    title: "Something went wrong",
                    text: "Please try starting it again or contact customer care",
                    buttons: "Okay"
                })
            }
        }
    }


    const avaliablePlans = [
        {
            'id': 1,
            'planType': '1 month diet plan',
            'price': '₹149',
            'value' :  'one_month_smart_paid_diet_plan'
        },
        {
            'id': 2,
            'planType': '3 month diet plan',
            'price': '₹399',
            'value' :  'three_month_smart_paid_diet_plan'
        },
        {
            'id': 3,
            'planType': '6 month diet plan',
            'price': '₹799',
            'value' :  'six_month_smart_paid_diet_plan'
            
        }
    ]

    const handleOnChange = (event, option) =>{
        setselectedPlanType(event.target.value)
    }

    return(
        <>
            <PlanHeader header={categoryTemp.header} title={categoryTemp.title} subtitle={categoryTemp.subtitle} />
            <div className='plan-benefit mb-4 px-4'>
                <img src={categoryTemp?.benefit} alt=""  />
            </div>
            <Feature />
            {/* <div className='plan-reward mb-4'>
                <img src={rewardImg} alt=""  />
            </div> */}
            {categoryTemp?.userTestimonial && <Testimonial data={categoryTemp?.userTestimonial} />}
            <FAQ />
            <div className='mb-5'></div>
            <div className="empty-space-82"></div>
            {!state?.timerDisplay && 
                <div className="fix-div-button">
                    <Button className="risk-btn" onClick={() => setOpen(true)}>Continue</Button>
                </div>
            }
            

            <BottomSheet open={open} onDismiss={() => setOpen(false)}>
                <h2 className='mt-4 mb-3
                 ms-3 bottom-sheet-title'>Proceed to pay</h2>

                <RadioButton radioList={avaliablePlans} selectedPlanType={selectedPlanType} onClickRadio={handleOnChange} personalisedImg={personalisedImg} />
                
                {user?.osType === 'android' ?
                    <div className='px-2 mb-4'>
                        <Button className="risk-btn mb-2" onClick={() => onClickMakePayment('')} isDisabled={isDisabled}>Make Payment</Button>
                        <div className='text-center'>
                            <Link className='free-diet-plan-link' to="/dietPlan/couponCodeActivation">Have a coupon Code</Link>
                        </div>
                        {/* <Button className="risk-btn mb-2" onClick={() => onClickMakePayment('upi')} isDisabled={isDisabled}>Pay ₹499 via UPI</Button> */}
                        {/* <Button className="risk-btn" onClick={() => onClickMakePayment('')} isDisabled={isDisabled}>Choose other payment method</Button> */}
                        {/* <Button className="risk-btn" onClick={() => onClickMakePayment('upi')} isDisabled={isDisabled}>Make payment</Button> */}
                    </div> : 
                    <div className='px-2 mb-4'>
                        <Button className="risk-btn" onClick={() => onClickMakePayment('')} isDisabled={isDisabled}>Make payment</Button>
                    </div>
                }
                
                {/* As Discuss with Anil removing T&C */}
                {/* <div className='payment-condition terms-and-condition-p text-muted'>
                    By making payment you agree to our <span onClick={openTermsAndConditionWeb}>T&C</span>
                </div> */}
                
            </BottomSheet>
            { state?.timerDisplay && <DietPlanTimer /> }
        </>
    )
}

export default PlanDetail;